import { Button, Checkbox } from '@design-system';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';

import { SimpleDialog } from '../../../Dialog/SimpleDialog';

export type AddCardDialogProps = {
  /** Stripe card Elements, injected by the wrapper. */
  cardFields: ReactNode;
  /** Stripe billing `AddressElement`, shown when billing differs from shipping. */
  billingAddressFields?: ReactNode;
  billingSameAsShipping: boolean;
  saveCard: boolean;
  canSave?: boolean;
  isSaving?: boolean;
  error?: ReactNode;
  onBillingSameAsShippingChange: (billingSameAsShipping: boolean) => void;
  onSaveCardChange: (saveCard: boolean) => void;
  onSave: () => void;
  onClose: () => void;
};

export const AddCardDialog = ({
  billingAddressFields,
  billingSameAsShipping,
  canSave = true,
  cardFields,
  error,
  isSaving,
  onBillingSameAsShippingChange,
  onClose,
  onSave,
  onSaveCardChange,
  saveCard,
}: AddCardDialogProps) => {
  const { t } = useTranslation('checkout');

  return (
    <SimpleDialog
      centered
      onClose={onClose}
      open
      title={t('details.paymentCard.addTitle')}
    >
      <div className="flex flex-col gap-3">
        {error}

        {cardFields}

        <Checkbox
          checked={billingSameAsShipping}
          id="details-dialog-billing-same-as-shipping"
          label={t('details.paymentCard.billingSameAsShipping')}
          name="details-dialog-billing-same-as-shipping"
          onChange={(e) =>
            onBillingSameAsShippingChange(e.currentTarget.checked)
          }
          type="checkbox"
        />

        {!billingSameAsShipping && billingAddressFields}

        <Checkbox
          checked={saveCard}
          id="details-dialog-save-card"
          label={t('details.paymentCard.save')}
          name="details-dialog-save-card"
          onChange={(e) => onSaveCardChange(e.currentTarget.checked)}
          type="checkbox"
        />

        <Button
          disabled={!canSave || isSaving}
          fullWidth
          label={t('details.save')}
          loading={isSaving}
          onClick={onSave}
          variant="primary"
        />
      </div>
    </SimpleDialog>
  );
};
